import axios, { type AxiosResponse } from 'axios'
import type {
  PageResponse,
  Response,
  ConstDataListItem,
  GetSimpleDictDataListRes,
  LangDataItem,
  ThemeSubItem,
  VersionConfig
} from '@/types'
import { http } from '@/utils/http.ts'

/**
 * 获得全部主题子数据数据列表
 */
export const getThemeVars = (): Promise<ThemeSubItem[]> => {
  return http<Response<ThemeSubItem[]>>('/app-api/system/theme/sub-list', {
    method: 'post',
    noMsg: true,
    body: {}
  }).then((res) => {
    return res.data || []
  })
}

/**
 * 将主题数组转换为Map格式
 * @param themeArray 主题数组
 */
export const createThemeMap = (themeArray: ThemeSubItem[]): Map<string, ThemeSubItem> => {
  return new Map(themeArray.map((item) => [item.themeKey, item]))
}

/**
 * 获得全部主题子数据数据列表 (返回Map) - 向后兼容
 * @deprecated 建议使用 getThemeVars() 结合 createThemeMap()
 */
export const getThemeVarsMap = (): Promise<Map<string, ThemeSubItem>> => {
  return getThemeVars().then(createThemeMap)
}
/**
 *
 * 查询常量列表接口
 */
export const apiConfigList = (): Promise<ConstDataListItem[]> => {
  return http<Response<ConstDataListItem[]>>('/app-api/infra/config/list', {
    method: 'post',
    body: {},
    noMsg: true
  }).then((res) => {
    return res.data || []
  })
}

// 后台参数字典-查询
export const getSimpleDictDataList = () => {
  return http<Response<GetSimpleDictDataListRes[]>>('/app-api/account/dict-data/list', {
    method: 'post',
    body: {},
    noMsg: true
  }).then((res) => {
    return res.data || []
  })
}

/**
 * 获取多语言
 * 语言分类 (0:java,1:h5/app,2:后台管理)
 */
export const apiLangData = async (): Promise<LangDataItem[]> => {
  return http<Response<LangDataItem[]>>('/app-api/system/lang-data/release-list', {
    method: 'post',
    body: { langType: 1 }
  }).then((res) =>
    (res.data ?? []).map((item) => {
      // 处理换行符
      item.langValueZh = item.langValueZh!.replace(/\\n/g, '<br>')
      item.langValueEn = item.langValueEn!.replace(/\\n/g, '<br>')
      item.langValueVi = item.langValueVi!.replace(/\\n/g, '<br>')
      return item
    })
  )
}

// 手机区号
export const getAreas = async () => {
  return http<Response<LangDataItem[]>>('/app-api/system/lang-data/release-list/country', {
    method: 'post',
    body: { langType: 3 }
  })
}

export const checkVersion = async (): Promise<AxiosResponse<string, string>> => {
  return axios.get(`/index.html?v=${Date.now()}`)
}

export function getAppVersion() {
  return http<Response<VersionConfig>>('/app-api/system/versionManagement/lastVersion')
}

// 查询banner配置 1首页banner 2 存款banner 3首页弹窗 4积分弹窗 5主系统侧边栏banner
export async function getBannerList(data: { model: { imgType: number } }) {
  return http<PageResponse<any>>('/app-api/member/banner/list', {
    method: 'POST',
    body: data
  })
}
